import React, { ReactNode, useEffect, useState } from "react";
import { Container, StyledTable } from "./styles";
import {
  Badge,
  Button,
  Select,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { getUser } from "../../context/token";
import dayjs from "dayjs";

type linhas = {
  col1: string;
  col2: string;
  col3: string;
  col4?: string;
  col5?: boolean;
  id?: any;
};
interface ITableProps {
  title: string;
  header1: string;
  header2: string;
  header3: string;
  header4?: string;
  body: linhas[];
  children?: ReactNode;
  status: string;
  tabelaAgendamentos?: string;
  callback?: Function;
}

const Tables = ({
  title,
  header1,
  header2,
  header3,
  header4,
  body,
  children,
  status,
  callback,
  tabelaAgendamentos
}: ITableProps) => {
  const { email } = getUser();
  const [filterAgendamento, setFilterAgendamento] = useState("")
  const [agendamentos, setAgendamentos] = useState<linhas[]>([])

  async function filtrarstatus(status: string){
  
    switch (status) {
      case "option1": {
        setAgendamentos(body)
        break;
      }
      case "option2":{
        const result = body.filter((item)=> dayjs(item.col2).diff(dayjs(), 'day') >= dayjs().diff(dayjs(), 'day') && item.col5 == false);
        setAgendamentos(result)
        break;
      }  
      case "option3":{
        const result = body.filter((item)=> item.col5 == true);
        setAgendamentos(result)
        break;
      }  
      case "option4":{
        const result = body.filter((item)=> dayjs(item.col2).diff(dayjs(), 'day') < dayjs().diff(dayjs(), 'day') && item.col5 == false);
        setAgendamentos(result)
        break;
      }  
      default:
        break;
    }
  }
  useEffect(() => {
    filtrarstatus(filterAgendamento);
  }, [filterAgendamento]);

  return (
    <Container>
      <div className="title">
        <h1>{title}</h1>

        <div className="btn-evento">{children}</div>

        {tabelaAgendamentos?
        <div className="selectstatus">
          <Select mt={'1rem'} placeholder='Selecione uma opção' size='md' onChange={(e) => setFilterAgendamento(e.target.value) }>
            <option value='option1'>Todas entrevistas</option>
            <option value='option2'>Aguardando entrevista</option>
            <option value='option3'>Entrevista realizada</option>
            <option value='option4'>Não compareceu</option>
          </Select>
        </div>
          :
          <></>  
        }

      </div>

      <TableContainer
        className="table"
        border={"1px solid #CCCCCC"}
        borderRadius={10}
        mt={35}
        bg={"#FFFFF"}
      >
        <StyledTable colorScheme="gray">
          <Thead>
            <Tr bg={"#CCCCCC"} color={"#3F3D56"}>
              <Th fontSize={22} color={"#3F3D56"}>
                {header1}
              </Th>
              <Th fontSize={22} color={"#3F3D56"}>
                {header2}
              </Th>
              <Th fontSize={22} color={"#3F3D56"}>
                {header3}
              </Th>
              <Th fontSize={22} color={"#3F3D56"}>
                {header4}
              </Th>
              {tabelaAgendamentos && status == "3"?
                <Th fontSize={22} color={"#3F3D56"}>
                  Status
                </Th>
                :
                <></>  
            }
              {status == "2" || status == "3"?
                <Th fontSize={22} color={"#3F3D56"}>
                
                </Th>
                :
              <></>}
            </Tr>
          </Thead>
          <Tbody overflowY={"scroll"}>          
            {(() => {
              switch (status) {
                case "1":
                  return body.map((linha) => (
                    <Tr>
                      <Td fontSize={20}>{linha.col1}</Td>
                      <Td fontSize={20}>{linha.col2}</Td>
                      <Td fontSize={20}>{linha.col3}</Td>
                      <Td fontSize={20}>{linha.col4}</Td>
                    </Tr>
                  ));
                  case "2":
                    return body.map((linha) => (
                      <Tr>
                        <Td fontSize={20}>{linha.col1}</Td>
                        <Td fontSize={20}>{linha.col2}</Td>
                        <Td fontSize={20}>{linha.col3}</Td>
                        <Td fontSize={20}>{linha.col4}</Td>
                        <Td>
                        <Button h={"auto"} pt={1} pb={1.5} bg={"#3f3d56"} color={"#ffffff"} _hover={{backgroundColor: "#343341"}} onClick={() => (callback ? callback(linha.id) : <></>)}>Ver Mais</Button>
 
                      </Td>
                      </Tr>
                    ));
                case "3":
                if(filterAgendamento !== ""){
                  return agendamentos.map((linha) => (
                    <Tr>
                      <Td fontSize={20}>{linha.col1}</Td>
                      <Td fontSize={20}>{dayjs(linha.col2).format('DD/MM/YYYY')}</Td>
                      <Td fontSize={20}>{linha.col3}</Td>
                      <Td fontSize={20}>{linha.col4}</Td>
                  
                      { tabelaAgendamentos &&
                        <Td>
                          {
                          dayjs(linha.col2).diff(dayjs(), 'day') >= dayjs().diff(dayjs(), 'day') && linha.col5 == false?
                          <Badge p={'0.3rem'} colorScheme='yellow'>Aguardando Entrevista</Badge>
                          :
                          dayjs(linha.col2).diff(dayjs(), 'day') < dayjs().diff(dayjs(), 'day') && linha.col5 == false? 
                          <Badge p={'0.3rem'} colorScheme='red'>Não compareceu</Badge>
                          :
                          linha.col5 == true?
                          <Badge p={'0.3rem'} colorScheme='green'>Entrevista realizada</Badge>
                          :
                          <></>
                        }
                          </Td>
                  
                        }
                          
                      <Td>
                        <Button h={"auto"} pt={1} pb={1.5} bg={"#3f3d56"} color={"#ffffff"} _hover={{backgroundColor: "#343341"}} onClick={() => (callback ? callback(linha.id) : <></>)}>Ver Mais</Button>
                      </Td>
                    </Tr>
                  ));
                }else{
                  return body.map((linha) => (
                    <Tr>
                      <Td fontSize={20}>{linha.col1}</Td>
                      <Td fontSize={20}>{dayjs(linha.col2).format('DD/MM/YYYY')}</Td>
                      <Td fontSize={20}>{linha.col3}</Td>
                      <Td fontSize={20}>{linha.col4}</Td>
                      
                      { tabelaAgendamentos &&
                        <Td>
                          {
                          dayjs(linha.col2).diff(dayjs(), 'day') >= dayjs().diff(dayjs(), 'day') && linha.col5 == false?
                          <Badge p={'0.3rem'} colorScheme='yellow'>Aguardando Entrevista</Badge>
                          :
                          dayjs(linha.col2).diff(dayjs(), 'day') < dayjs().diff(dayjs(), 'day') && linha.col5 == false? 
                          <Badge p={'0.3rem'} colorScheme='red'>Não compareceu</Badge>
                          :
                          linha.col5 == true?
                          <Badge p={'0.3rem'} colorScheme='green'>Entrevista realizada</Badge>
                          :
                          <></>
                        }
                          </Td>
                        }
                     
                     
                      <Td>
                        <Button h={"auto"} pt={1} pb={1.5} bg={"#3f3d56"} color={"#ffffff"} _hover={{backgroundColor: "#343341"}} onClick={() => (callback ? callback(linha.id) : <></>)}>Ver Mais</Button>
 
                      </Td>
                    </Tr>
                  ));
                }
                default:
                  return;
              }
            })()}
          </Tbody>
        </StyledTable>
      </TableContainer>
    </Container>
  );
};

export { Tables };
